/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SchemaField, Document, DocumentSchema } from '../../../store/models/document.model';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models/workflow.model';
import { DocumentReader } from '../../../store/models/document-reader';
import { TranslateService } from '@ngx-translate/core';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { CultureService } from '../../../services/culture.service';

@Component({
    selector: 'app-document-summary',
    templateUrl: './document-summary.component.html',
    styleUrls: ['./document-summary.component.scss'],
    standalone: false
})
export class DocumentSummaryComponent implements DynamicField, OnDestroy {
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() isEdit: boolean;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  reader: DocumentReader;
  @Input() dataset: Dataset;
  @Input() schema: DocumentSchema;
  @Input() viewComponent: ViewComponent;
  value: any;

  type: string;
  titleLevel1: string;
  titleLevel2: string;
  titleLevel3: string;

  constructor(private translate: TranslateService, private cultureService: CultureService) {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  tpOnContentUpdated(): void {
    this.populateType();

    this.populateTitleLevel1();

    this.populateTitleLevel2();

    this.populateTitleLevel3();
  }

  populateType(): void {
    const fieldName = this.viewComponent?.configuration?.typeField || 'alert_type';

    if (this.schema) {
      const field = this.schema.fields.find(f => f.systemName === fieldName);
      this.type = this.reader.getFormattedFieldValue(fieldName, field, this.cultureService);
    }
  }

  populateTitleLevel1(): void {
    const fieldNames = [
      this.viewComponent?.configuration?.titleField || 'summary',
      'name',
      'title',
      'location_name',
      'subject',
      'email_subject',
      'report_name',
      'details_name',
      'content'
    ];

    let field: SchemaField = null;
    if (this.schema) {
      for (const fieldName of fieldNames) {
        field = this.schema.fields.find(f => f.systemName === fieldName);
        if (field) {
          break;
        }
      }
    }

    if (field) {
      this.titleLevel1 = this.reader.getFormattedFieldValue(field.systemName, field, this.cultureService);
    }
  }

  populateTitleLevel2(): void {
    const fieldName = this.viewComponent?.configuration?.subTitleField || 'alert_source';

    if (this.schema) {
      const field = this.schema.fields.find(f => f.systemName === fieldName);
      this.titleLevel2 = this.reader.getFormattedFieldValue(fieldName, field, this.cultureService);
    }
  }

  populateTitleLevel3(): void {
    const fieldName = this.viewComponent?.configuration?.subSubTitleField || 'date_created';

    if (this.schema) {
      const field = this.schema.fields.find(f => f.systemName === fieldName);
      this.titleLevel3 = this.reader.getFormattedFieldValue(fieldName, field, this.cultureService);
    }
  }
}
